import React from 'react';
import PropTypes from 'prop-types';
import Property from '../property/property';
import { Icon } from '@cbrebuild/blocks';
import PaymentStatusIndicator from './payment-status-indicator';
import formatPaymentDate from '../../utils/format-payment-date';
import formatAccountingDate from '../../utils/format-accounting-date';
import Currency from '../../nucleus/formats/currency';
import Tooltip from '../../nucleus/tooltip/tooltip';

const MyPaymentsTableRow = ({ payment, showOutstandingBalance }) => (
  <tr>
    <td>
      <Property
        building={payment.transaction && payment.transaction.final_properties && payment.transaction.final_properties[0]}
        callToAction={null}
      />
    </td>
    <td>{payment.installment_number}</td>
    <td><span>{formatAccountingDate(payment)}</span></td>
    <td>
        <div>
            <PaymentStatusIndicator status={payment.payment_status} />
            <span>{formatPaymentDate(payment)}</span>
            {payment.payment_status === 'Paid' && typeof payment.outstanding_balance === 'number' && payment.outstanding_balance > 0 &&
            <Tooltip
              message={
                showOutstandingBalance ? (
                  <>
                    The outstanding balance on installment #{payment.installment_number} is <strong>${payment.outstanding_balance || 0}</strong>. Contact your Finance Team on
                    invoicing and submit a voucher revision with more installments if needed.{' '}
                  </>
                ) : (
                  <>
                    This installment was partially paid. Please contact Business Operations for more
                    info.
                  </>
                )
              }
            >
              <Icon iconName="info-circle" />
            </Tooltip>
            }
        </div>
    </td>
    <td>
      <Currency value={payment.gross_amount} />
    </td>
    <td>
      <Currency value={payment.total_net_amount} />
    </td>
    <td>
      {payment.transaction &&
        <a href={`/deals/detail/${payment.related_deal_id || payment.transaction.id}/commissions`} target="_self">
          {payment.related_deal_name || payment.transaction.name}
        </a>
      }
      <div>{payment.deal_id || '--'}</div>
    </td>
  </tr>
);

MyPaymentsTableRow.propTypes = {
  payment: PropTypes.shape({
    deal_id: PropTypes.string,
    payment_status: PropTypes.string,
    gross_amount: PropTypes.number,
    installment_number: PropTypes.number,
    total_net_amount: PropTypes.number,
    related_deal_id: PropTypes.number,
    related_deal_name: PropTypes.string,
    transaction: PropTypes.shape({
      id: PropTypes.number,
      final_properties: PropTypes.arrayOf(PropTypes.shape({})),
      name: PropTypes.string,
    }),
  }).isRequired,
};

const MyPaymentsTable = ({ payments, isLoading }) => {
  const showOutstandingBalance = true;
  return (
  <table className="my-payments-table">
    <colgroup>
      <col name="final property" width="20%" />
      <col name="installment #" width="10%" />
      <col name="revenue booked" width="12%" />
      <col name="status" width="14%" />
      <col name="gross" width="10%" />
      <col name="net" width="10%" />
      <col name="deal" width="24%" />
    </colgroup>
    <tbody>
      <tr className="dark-table-row">
        <th>Final Property</th>
        <th>Installment #</th>
        <th>Revenue Booked</th>
        <th>Payment Status</th>
        <th>Gross</th>
        <th>Net</th>
        <th>Deal</th>
      </tr>
      {payments.map(payment => (
        <MyPaymentsTableRow
          showOutstandingBalance={showOutstandingBalance}
          key={payment.id}
          payment={payment}
        />
      ))}
      {!payments.length && !isLoading && (
        <tr className="empty-state-row">
          <td colSpan="6" >
            No payments data found with current filter.
            Please adjust your filter to see results.
          </td>
        </tr>
      )}
    </tbody>
  </table>
);
}

MyPaymentsTable.propTypes = {
  payments: PropTypes.arrayOf(PropTypes.shape({
    transaction: PropTypes.shape({}),
  })).isRequired,
  isLoading: PropTypes.bool,
};

MyPaymentsTable.defaultProps = {
  isLoading: false,
};

export default MyPaymentsTable;
